import type {
  EnterpriseProgramFieldsFragment as EnterpriseProgram,
  ProgramInvitationFieldsFragment as ProgramInvitation,
} from 'bundles/program-home/queries/__generated__/EnterpriseHomePageQuery';

export function handleProgramRedirect(
  userId: number | null,
  enterprisePrograms: EnterpriseProgram[],
  programInvitations: ProgramInvitation[]
) {
  const isValidUser = userId && (enterprisePrograms.length > 0 || programInvitations.length > 0);

  // if only one program / invitation, redirect to that program or invitation
  if (isValidUser && enterprisePrograms.length + programInvitations.length === 1) {
    let programSlug: string | undefined;
    if (enterprisePrograms.length === 1) {
      // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      programSlug = enterprisePrograms[0].metadata.slug;
    } else {
      // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      programSlug = programInvitations[0].userRoster?.program?.metadata.slug;
    }

    if (programSlug) {
      return `/programs/${programSlug}`;
    }
  }

  return null;
}
